/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Hero_LeadInputs */

const es_cap_hero_lead = /** @type {(inputs: Cap_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada vez más armadores necesitan un patrón de confianza para sus salidas. Tú pones la experiencia; nosotros te traemos los clientes. Sin jefe, sin horarios fijos, sin compromisos.`)
};

const gl_cap_hero_lead = /** @type {(inputs: Cap_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada vez máis armadores precisan un patrón de confianza para as súas saídas. Ti poñes a experiencia; nós traemos clientes. Sen xefe, sen horarios fixos, sen compromisos.`)
};

const en_cap_hero_lead = /** @type {(inputs: Cap_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More and more boat owners need a trusted skipper for their trips. You bring the experience; we bring the clients. No boss, no fixed hours, no strings attached.`)
};

/**
* | output |
* | --- |
* | "More and more boat owners need a trusted skipper for their trips. You bring the experience; we bring the clients. No boss, no fixed hours, no strings attached." |
*
* @param {Cap_Hero_LeadInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_hero_lead = /** @type {((inputs?: Cap_Hero_LeadInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Hero_LeadInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_hero_lead(inputs)
	if (locale === "en") return en_cap_hero_lead(inputs)
	return es_cap_hero_lead(inputs)
});